import { MailTwoTone } from "@ant-design/icons";
import { assertNever } from "@p0security/shared/types/index";
import {
  RequestNotificationKey,
  RequestNotifications,
} from "@p0security/shared/types/permission";
import { Button, Flex } from "antd";
import { SlackLogo } from "components/Integrations/Slack/Slack";
import { TeamsLogo } from "components/Integrations/Teams/TeamsLogo";
import React from "react";
import { spacing } from "styles/spacing";

import { WebexLogo } from "../../../Integrations/Webex/WebexLogo.tsx";
import { VALID_MESSAGE_TLD } from "../requestUtils";

export const NotifierConversationLinks: React.FC<{
  notifications?: RequestNotifications;
}> = ({ notifications }) => {
  return (
    <Flex gap={spacing.scale.xs} align="center">
      {notifications?.slack?.approvalConversationUrl && (
        <ConversationLink
          url={notifications.slack.approvalConversationUrl}
          notifier="slack"
        />
      )}
      {notifications?.msTeams?.approvalConversationUrl && (
        <ConversationLink
          url={notifications.msTeams.approvalConversationUrl}
          notifier="msTeams"
        />
      )}
      {notifications?.email?.approvalEmailData && (
        <NotifierLogo notifier="email" />
      )}
    </Flex>
  );
};

const ConversationLink: React.FC<{
  url: string;
  notifier: RequestNotificationKey;
}> = ({ url, notifier }) => {
  // Prevent most XSS with this sanitizer; note that this is theoretically redundant
  // as our backend should only write the link with trusted data from Slack anyway
  const hostname = new URL(url).hostname;
  const isValid =
    url && VALID_MESSAGE_TLD.some((domain) => hostname.endsWith(domain));
  return (
    <>
      {isValid && (
        <Button
          type="link"
          href={url}
          icon={<NotifierLogo notifier={notifier} />}
          style={{
            padding: 0,
            margin: 0,
            height: "auto",
            width: "auto",
          }}
          target="_blank"
          rel="noopener noreferrer"
        />
      )}
    </>
  );
};

const NotifierLogo: React.FC<{ notifier: RequestNotificationKey }> = ({
  notifier,
}) => {
  switch (notifier) {
    case "slack":
      return <SlackLogo size={spacing.scale.lg} />;
    case "msTeams":
      return <TeamsLogo size={spacing.scale.lg} />;
    case "email":
      return (
        <MailTwoTone size={spacing.scale.lg} style={{ marginBottom: -2 }} />
      );
    case "webex":
      return <WebexLogo size={spacing.scale.lg} />;
    default:
      assertNever(notifier);
      return <span />;
  }
};
